import { AppBar, Box, Button, ButtonGroup, Toolbar, Tooltip, Typography } from "@mui/material";
import RefreshIcon from "@mui/icons-material/Refresh";
import OpenWithIcon from "@mui/icons-material/OpenWith";

export interface Buttons {
    label?: React.ReactNode;
    click?: () => void;
    button?: React.ReactNode;
}

export interface PrizaGridBarProps {
    open?: boolean;
    closed?: boolean;
    toolbar: {
        label: React.ReactNode;
        buttons?: Buttons[];
    }
    retry?: () => void;
    handleOpenClose?: () => void;
}

const PrizaGridBar = (props: PrizaGridBarProps) => {
    const retry = props.retry;
    const closed = props.closed;

    const localHandleOpenClose = () => {
        console.log("localHandleOpenClose");
        if (props.handleOpenClose) {
            props.handleOpenClose();
        }
    };

    return <AppBar position="static" color={closed ? "secondary" : "primary"} sx={{ top: "auto", bottom: 0 }}>
        <Toolbar>
            <Typography onClick={localHandleOpenClose} variant="h6" component="div" sx={{ flexGrow: 1 }}> {props.toolbar.label} </Typography>
            <Box sx={{ flexGrow: 1 }} />
            {
                closed
                ?   <Button key="open" variant="contained" color="primary" onClick={localHandleOpenClose}>
                        <Tooltip title="Mostrar" >
                            <OpenWithIcon />
                        </Tooltip>
                    </Button>
                :   <ButtonGroup variant="contained" color="secondary">
                        {
                            props.toolbar.buttons?.map((item, i) => {
                                if(item.button) {
                                    return item.button;
                                }
                                return <Button key={i} onClick={(/* event */) => {
                                    if(item.click) {
                                        item.click(/* event */); 
                                    }
                                }}>{item.label}</Button>;
                            })
                        }
                        {
                            retry
                                ? <Button key="refresh" onClick={(/* event */) => { retry(); }}>
                                    <Tooltip title="Atualizar" >
                                        <RefreshIcon />
                                    </Tooltip>
                                </Button>
                                : undefined
                        }
                    </ButtonGroup>
            }
        </Toolbar>
    </AppBar>;
};

export default PrizaGridBar;